import gql from "graphql-tag";

const gqlQuery = gql`
  query MixerSlotsData($roomTemplateId: ID, $graphicSetId: ID, $contractId: ID) {
    mixerSlotsData(roomTemplateId: $roomTemplateId, graphicSetId: $graphicSetId, contractId: $contractId) {
      roomTemplate {
        id
        maxWindowMixer
      }
      graphicSet {
        id
        customerId
        name
        layouts {
          sendTo
        }
      }
    }
  }
`;

export default ({ roomTemplateId, graphicSetId, contractId, skip = false }) => ({
  query: gqlQuery,
  skip: skip || !roomTemplateId || !graphicSetId || !contractId,
  variables: { roomTemplateId, graphicSetId, contractId },
});
